"use client";
import { useQuery } from "@apollo/client/react";

import { Follows } from "@/components/follows/follows";
import { ADMIN_USER } from "@/gql/queries/admin-user";

type StudioAdminItemsProps = {
  username: string;
}

export default function StudioAdminRelatedUsers({ username }: StudioAdminItemsProps) {
  const { data, loading } = useQuery(ADMIN_USER, { variables: { name: username } });

  if (loading || !data?.adminUser?.id) return null;

  return (<><Follows
    title="Related by IP"
    users={data?.adminUser?.relatedUsersByIp ?? []}
  />
    <Follows
      title="Related by clientId"
      users={data?.adminUser?.relatedUsersByClientId ?? []}
    /></>)
}